export const NATIVE_TOKEN_ADDRESS = '0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB' as const;
export const IMAGES_DIR_NAME = 'images';
export const IMAGES_DIR_PATH = `src/${IMAGES_DIR_NAME}`;

export const MS_PER_DAY = 1000 * 60 * 60 * 24;
